import React, {
  CSSProperties,
  FC,
  useCallback,
  useContext,
  useLayoutEffect,
  useRef,
} from 'react';
import { Column } from 'react-table';

import { Context } from './WorkHours';

const validateRE = /^\d+|\d+\.|\.\d+|\d+\.\d+$/;

interface Props {
  value: { hours: number; style: CSSProperties } | string;
  original: any;
  column: Column & any;
}

const EditableCell: FC<Props> = ({ value, original, column }) => {
  const { focused, setFocused, classes, changeHour } = useContext(Context);
  const rootRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    if (focused && focused.row === original.id && focused.col === +column.id) {
      rootRef.current?.focus();
      const selection = window.getSelection();
      const range = document.createRange();
      if (rootRef.current) range.selectNodeContents(rootRef.current);
      selection?.removeAllRanges();
      selection?.addRange(range);
    } else if (document.activeElement === rootRef.current) {
      rootRef.current?.blur();
    }
  }, [column.id, focused, original.id]);

  const setFocus = useCallback(() => {
    setFocused({ row: original.id, col: +column.id });
  }, [setFocused, original.id, column.id]);

  let content = '';
  const blurHandler = (e: React.FocusEvent): void => {
    const text = e.target.textContent ?? '';

    if (validateRE.test(text) && text.length > 0) {
      if (+text === 0 && rootRef.current) {
        rootRef.current.textContent = '';
      }
      if (text !== content) {
        changeHour(original.hourTypeId, +column.id, text);
      }
    } else if (rootRef.current) {
      rootRef.current.textContent = '';
      changeHour(original.hourTypeId, +column.id, '');
    }
  };

  if (value !== undefined) {
    if (typeof value !== 'string' && value.hours !== undefined) {
      content = value.hours === 0 ? '' : value.hours.toString();
    } else {
      content = value.toString();
    }
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      ref={rootRef}
      contentEditable={original.itemNo !== undefined && !column.disabled}
      suppressContentEditableWarning
      style={
        typeof value !== 'string' && value?.style ? value.style : undefined
      }
      onBlur={blurHandler}
      onClick={setFocus}
      className={classes.hourCell}
    >
      {content}
    </div>
  );
};

// TODO: react-table crashes for some reason when React.memo is used
// const shouldUpdate = (p1: Props, p2: Props) =>
//   p2.value ? p1.value === p2.value : false;

export default EditableCell;
